<template>
  <!-- header-menu contains the MOBILE HEADER, the MAIN HEADER and below the NAVIGATION HEADER -->
  <div id="header-menu">
    <!-- MAIN HEADER  -->
    <b-navbar
      toggleable="lg"
      fixed="top"
      class="header-color header-width pt-0 pb-0"
      type="light"
      style="z-index: 1040;"
      :style="headerStyle"
    >
      <!-- MOBILE MAIN HEADER -->
      <button target="nav_collapse" @click="burgerClick()" class="d-block d-lg-none burger">
        <span class="navbar-toggler-icon"></span>
      </button>

      <b-navbar-brand to="/" class="d-block d-lg-none">
        <img
          :src="brandingData.brandLogoUrl"
          alt="VENIQA"
          width="125px"
          style="padding: 0.5rem 0rem;"
        >
      </b-navbar-brand>

      <b-nav-item 
        class="d-block d-lg-none"
        v-if="isEnabled('cart-enabled')"
        @click="$emit('openCart')"
      >
        <font-awesome-icon icon="shopping-cart" style="font-size: 1.2em"/>
        <b-badge :pill="true" variant="danger">{{totalOrders}}</b-badge>
      </b-nav-item>

      <div class="mobile-search-bar d-block d-lg-none">
        <input
          type="text"
          class="special-search-input"
          :placeholder="$t('headerMenu.searchHolder')"
          v-model="searchTerm"
          style="width: 100%"
          @keyup.enter="searchProduct()"
          @keydown.esc="showSearch = false"
        >
      </div>

      <!-- DESKTOP MAIN HEADER -->
      <transition
        name="shipping-form-anim"
        enter-active-class="animated slideInLeft slower"
        leave-active-class="animated slideOutLeft slower"
      >
        <b-collapse is-nav id="nav_collapse" class="collapsible-content">
          <b-navbar-brand to="/" class="brand-logo d-none d-lg-block">
            <img
              :src="brandingData.brandLogoUrl"
              alt="VENIQA"
              width="125px"
            >
          </b-navbar-brand>

          <!-- Search Bar -->
          <b-navbar-nav class="main-header-nav search-container">
            <transition
              name="shipping-form-anim"
              enter-active-class="animated fadeInRight faster"
              leave-active-class="animated fadeOutLeft faster"
            >
              <input
                type="text"
                class="search-input d-none d-lg-block"
                :placeholder="$t('headerMenu.searchHolder')"
                v-model="searchTerm"
                @keyup.enter="searchProduct()"
                @keydown.esc="unsetFocus($event)"
              >
            </transition>
            <button @click="searchProduct()" class="search-btn veniqa-nav d-none d-lg-block">
              <font-awesome-icon
                style="color: rgba(255, 255, 255, 0.5)"
                class="icon h-40 w-100"
                icon="search"
              />
            </button>
          </b-navbar-nav>

          <!-- User Navigation -->
          <b-navbar-nav class="main-header-nav">
            <!-- Login button -->
            <b-nav-item
              class="veniqa-nav d-none d-lg-block"
              to="/login"
              v-if="!isSessionActive && isEnabled('customer-accounts-enabled')"
            >
              <font-awesome-icon icon="user" style="font-size: 1.2em"/>
              <span style="width: max-content;">
                &nbsp;{{ $t('login') }}
              </span>
            </b-nav-item>

            <!-- User-account dropdown -->
            <b-nav-item-dropdown
              class="veniqa-nav d-none d-lg-block"
              :text="nameOfUser"
              left
              v-else-if="isSessionActive && isEnabled('customer-accounts-enabled')"
            >
              <b-dropdown-item to="/account">{{ $t('profile') }}</b-dropdown-item>
              <b-dropdown-item to="/orders">{{ $t('ordersLink') }}</b-dropdown-item>
              <b-dropdown-item @click="logoutClicked()">{{ $t('logout') }}</b-dropdown-item>
            </b-nav-item-dropdown>

            <!-- Cart button -->
            <b-nav-item
              class="veniqa-nav d-none d-lg-block"
              v-if="isEnabled('cart-enabled')"
              @click="$emit('openCart')"
            >
              <font-awesome-icon icon="shopping-cart" style="font-size: 1.2em"/>
              <b-badge :pill="true" variant="danger">{{totalOrders}}</b-badge>
            </b-nav-item>
          </b-navbar-nav>

          <!-- Displays only when collapsible option is true -->
          <div class="sidenav ml-auto d-block d-lg-none">
            <left-menu-view/>
            <!-- <div class="align-right close-icon">
              <font-awesome-icon v-b-toggle.nav_collapse icon="times"/>
            </div>
            <b-nav-item class="align-left collapse-nav" to="/vendor/amazon">Men's Clothing
              <hr>
            </b-nav-item>
            <b-nav-item class="align-left collapse-nav" to="/vendor/amazon">Women's Clothing
              <hr>
            </b-nav-item>
            <b-nav-item class="align-left collapse-nav">Profile
              <hr>
            </b-nav-item>
            <b-nav-item class="align-left collapse-nav" to="/login" v-if="!isSessionActive">Login</b-nav-item>
            <hr>
            <b-nav-item class="align-left collapse-nav" v-if="isSessionActive" to="/orders">Orders</b-nav-item>
            <b-nav-item
              class="d-none d-md-block collapse-nav"
              to="/login"
              v-if="!isSessionActive"
            >Login</b-nav-item>
            <b-nav-item class="align-left collapse-nav" @click="logoutClicked()" v-else>Logout</b-nav-item>-->
          </div>
          <!-- End of Collapsible view display -->
        </b-collapse>
      </transition>
    </b-navbar>

    <!-- Second header DESKTOP NAVIGATION HEADER (Added below the MAIN HEADER -->
    <b-navbar
      toggleable="lg"
      fixed="top"
      class="header-color header-width nav-header d-none d-lg-block"
      type="light"
      :style="headerStyle"
    >
    <transition
      name="shipping-form-anim"
      enter-active-class="animated slideInLeft slower"
      leave-active-class="animated slideOutLeft slower"
    >
      <b-collapse is-nav id="nav_collapse2" class="collapsible-content">
        <categories-navbar/>
      </b-collapse>
    </transition>
      
    </b-navbar>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import CategoriesNavbar from '@/components/CategoriesNavbar.vue';
import LeftMenuView from '@/components/LeftMenu.vue';

export default {
  name: 'HeaderMenu',
  components: {
    CategoriesNavbar,
    LeftMenuView,
  },
  props: {
    rightSidebarVisible: {
      type: Boolean,
      required: false,
      default: false,
    },

    sidebarWidth: {
      type: Number,
      required: false,
      default: 300,
    },
  },
  data() {
    return {
      scrollPos: null,
      showSearch: false,
      searchTerm: '',
      showDropdown: null,
    };
  },
  methods: {
    burgerClick() {
      this.$emit('activateSidebar');
    },

    isValidString(_string) {
      const regex = /^[a-zA-Z0-9()[\],.\s\u00C0-\u017F]+$/; // Only allows letters(accented too) numbers () [] , . and blank space
      return regex.test(_string);
    },

    searchProduct() {
      if (this.isValidString(this.searchTerm)) {
        this.$router.push({
          path: '/search',
          query: {
            term: this.searchTerm,
            categoryId: '',
            subcategoryId: ''
          },
        });
        // this.$store.commit('searchStore/setSearchTerm', this.searchTerm);
      } else {
        this.$notify({
          group: 'all',
          type: 'error',
          text: this.$t('headerMenu.errSearch'),
        });
      }
    },
    unsetFocus(event) {
      event.srcElement.blur();
    },
    async logoutClicked() {
      try {
        await this.$store.dispatch('authStore/logout');
        this.$notify({
          group: 'all',
          type: 'success',
          text: this.$t('successLogout'),
        });
        this.$store.commit('cartStore/resetOrders');
        this.$store.commit('shippingStore/resetAddresses');
        this.$router.push('/');
      } catch (err) {
        this.$notify({
          group: 'all',
          type: 'error',
          text: this.$t('errLogout'),
        });
      }
    },
  },

  computed: {
    nameOfUser() {
      return this.$store.getters['authStore/getFirstName'];
    },
    totalOrders() {
      return this.$store.getters['cartStore/getTotalItems'];
    },
    ...mapGetters({
      isSessionActive: 'authStore/isSessionActive',
      brandingData: 'siteDataStore/brandingData',
      isEnabled: 'featureFlagStore/isEnabled'
    }),

    headerStyle() {
      return {
        'margin-right': this.rightSidebarVisible
          ? `${this.sidebarWidth}px`
          : '0px',
        // 'min-width': '100%'
      };
    },
  },
};
</script>
